var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back-to-top',{attrs:{"bottom":"20px","right":"30px"}},[_c('v-btn',{attrs:{"fab":"","dark":"","color":"primary"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("keyboard_arrow_up")])],1)],1),_c('chat-bot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }